import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlDocuments from './ControlDocuments.js';
import { getCandidateDocuments } from '../../../Api/ExtranetActions.js';

declare var globalSns;

class ExtranetCandidatesDocuments extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getCandidateDocuments(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                candidateDocuments: data
            });
        });
    }

    render() {
        if (this.state.candidateDocuments == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlDocuments documents={this.state.candidateDocuments} 
                        onNavigateToProjects={(row) => this.props.onNavigate("extranetProjectsFiche", row.projectId, row.project)} />
                </div>
            </div>
        );
    }
}

export default ExtranetCandidatesDocuments;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetCandidatesDocuments.js